/**
 * Manages the states of a button.
 **/
export default function button() {
  const triggerElement = document.querySelectorAll( '.bt-trigger-toggle' )

  triggerElement.forEach( button => {
    const buttonText = button.querySelector( '.leading-none' )
    const targetElement = document.querySelector( `.${button.dataset.target}` )

    targetElement.style.display = 'none'

    button.addEventListener( 'click', event => {
      event.preventDefault()

      if ( targetElement.style.display === 'none' ) {
        targetElement.style.display = 'block'
        buttonText.innerHTML = 'Ver menos'
      } else {
        targetElement.style.display = 'none'
        buttonText.innerHTML = 'Ver más'
      }
    })
  })
}
